import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, Grid, IconButton, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';
import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';
import { Layout } from '../../components/Layout'
import { TablePaginationActions } from '../../helpers/TablePaginationActions';
import { usePages } from '../../hooks/usePages';
import { useFilter } from '../../hooks/useFilter';
import { SearchTextField } from '../../components/SearchTextField';
import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';
import { TipoOficioProps } from '../../interfaces/catalogos/TipoOficioInterface';
import { ActualizarTipoOficio, AgregarTipoOficio, TipoOficios } from '../../connections/catalogos/TipoOficioConnection';
export const TipoOficioPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );
    const [TipoOficioArray, setTipoOficioArray] = useState<TipoOficioProps[]>( [] );
    const [openDialog, setOpenDialog] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );
    const [idTipoOficio, setIdTipoOficio] = useState( 0 );
    const [descripcion, setDescripcion] = useState( '' );
    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 5 );
    const { filtro, setFiltro, dataFiltrada } = useFilter( TipoOficioArray, ( item, filtro ) => item.descripcion?.toLowerCase().includes( filtro.toLowerCase() ) );
    const handleChangeChecked = async ( checked: boolean, id: number ) => {
        const TipoOficioSelected = TipoOficioArray.find( ( elem ) => elem.idTipoOficio === id );
        if ( TipoOficioSelected ) {
            await ActualizarTipoOficio({ ...TipoOficioSelected, activo: checked }).then( resp => {
                if ( resp.idTipoOficio ) {
                    var newArray = TipoOficioArray.map( ( elem ) => {
                    if ( elem.idTipoOficio === id ) {
                        elem.activo = checked;
                    }
                        return elem;
                    });
                    setTipoOficioArray( newArray );
                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));
                }
            });
        }
    }
    const handleGuardar = async () => {
        if ( idTipoOficio !== 0 ) {
            const TipoOficioSelected = TipoOficioArray.find( ( elem ) => elem.idTipoOficio === idTipoOficio );
            if ( TipoOficioSelected ) {
                setLoading( true );
                await ActualizarTipoOficio({ ...TipoOficioSelected, descripcion, }).then( resp => {
                    if ( resp.idTipoOficio ) {
                        setTimeout(() => {
                            var newArray = TipoOficioArray.map( ( elem ) => {
                                if ( elem.idTipoOficio === idTipoOficio ) {
                                    elem.descripcion = descripcion;
                                }
                                return elem;
                            });
                            setTipoOficioArray( newArray );
                            setOpenDialog( false );
                            setLoading( false );
                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));
                        }, 700);
                    }
                });
            }
        }
        else {
            const TipoOficioAdd: TipoOficioProps = {
                idTipoOficio: 0,
                descripcion,
                activo: true,
            }
            setLoading( true );
            await AgregarTipoOficio( TipoOficioAdd ).then( resp => {
                if ( resp.idTipoOficio ) {
                    setTimeout(() => {
                        setTipoOficioArray([ ...TipoOficioArray, resp ]);
                        setOpenDialog( false );
                        setLoading( false );
                        dispatch( openSnackbar({ message: 'Se agregó el tipo de oficio correctamente', variant: 'success' }));
                    }, 700);
                }
            });
        }
    }
    useEffect(() => {
        async function Obtener() {
            setLoadingData( true );
            setTipoOficioArray( [] );
            await TipoOficios().then( resp => {

                setTimeout(() => {

                    setTipoOficioArray( resp );
                    setLoadingData( false );

                }, 700);

            });

        }
        Obtener();
    }, [ ])
    return (
        <Layout breadcrumbs={ [ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Tipo de oficio' } ]} backgroundPaper={ false }>
            <Grid container spacing={ 3 } >
                <Grid size={{ xs: 6 }} textAlign={ 'start' }>
                    {
                        ( administrador || coordinador )
                        &&
                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }>
                                Regresar
                            </Button>
                    }
                </Grid>
                <Grid size={{ xs: 6 }} textAlign={ 'end' }>
                    <Button
                        variant='contained'
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ () => {
                            setIdTipoOficio( 0 );
                            setDescripcion( '' );
                            setOpenDialog( true );
                        }}
                    >
                        Agregar
                    </Button>
                </Grid>
            </Grid>
            <Grid container sx={{ mt: 2 }}>
                <Grid size={{ xs: 12 }}>
                    <SearchTextField
                        value={ filtro }
                        label='Buscar por descripción'
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />
                </Grid>
            </Grid>
            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>
                <Table sx={{ minWidth: 500 }}>
                    <TableHead sx={{ ...TableTheadStyle }}>
                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'75%' }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}>  </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            (
                                rowsPerPage > 0
                                ?
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                :
                                    dataFiltrada
                            )
                            .map( ( { idTipoOficio, descripcion, activo } ) => (
                                <TableRow key={ idTipoOficio } >
                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                        { idTipoOficio }
                                    </TableCell>
                                    <TableCell>
                                        { descripcion }
                                    </TableCell>
                                    <TableCell sx={{ textAlign: 'end' }}>
                                        <Switch
                                            checked={ activo }
                                            onChange={ ( e ) => handleChangeChecked( e.target.checked, idTipoOficio ) }
                                        />
                                        <IconButton
                                                color='primary'
                                                aria-label='edit'
                                                component='span'
                                                onClick={ () => {
                                                    setIdTipoOficio( idTipoOficio );
                                                    setDescripcion( descripcion );
                                                    setOpenDialog( true );
                                                }}
                                            >
                                            <EditIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 73 }}>
                                    <TableCell colSpan={ 7 } align='center'>
                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>
                                    </TableCell>
                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>
                                        <TableCell colSpan={ 7 } align='center'>
                                            <CircularProgress size={ 32 } />
                                        </TableCell>
                                    </TableRow>
                        }
                    </TableBody>
                    <TableFooter>
                        {
                            dataFiltrada.length !== 0
                            &&
                                <TableRow>
                                    <TableCell colSpan={ 1 } sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                            Total de registros: { dataFiltrada.length }
                                        </Typography>
                                    </TableCell>
                                    <TablePagination
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        colSpan={ 8 }
                                        count={ dataFiltrada.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                        ActionsComponent={ TablePaginationActions }
                                        labelRowsPerPage='Filas por página'
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />
                                </TableRow>
                        }
                    </TableFooter>
                </Table>
            </TableContainer>
            <Dialog open={  openDialog } maxWidth='sm' fullWidth={ true }>
                <DialogContent sx={ DialogContentStyle }>
                    <TextField
                        sx={{ mt: 3 }}
                        label={ 'Descripción' }
                        variant='outlined'
                        multiline
                        rows={ 4 }
                        fullWidth
                        value={ descripcion }
                        onChange={ (e) => setDescripcion( e.target.value ) }
                        slotProps={{
                            input: {
                                autoComplete: 'off'
                            },
                            inputLabel: {
                                shrink: true,
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' disabled={ loading } onClick={ () => { setOpenDialog( false ); } }> Cancelar </Button>
                    <Button loading={ loading } disabled={ descripcion === '' } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>
            </Dialog>
        </Layout>
    )
}